<span>ComForce</span> -> <span class="fw-bold"> Home</span>
<div class="mt-3">
  <iframe
    src="https://app.powerbi.com/reportEmbed?reportId=635a4834-88e6-450c-ac1b-e6b87a0764e8&autoAuth=true&ctid=0cd2b649-c383-4d3c-869a-e8736c423e8a"
    style="width:100%; height:100vh; border:0;"
    allowfullscreen>
  </iframe>
</div>
